// components/ImportContactForm.js (React-Komponente für CSV-Upload)
import React, { useState } from 'react';
import api from '../services/apiService';
import { Helmet } from 'react-helmet';

const ImportContactForm = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setError('');
    setSuccess('');
  };

  const handleImport = async () => {
    if (!file) {
      setError('Bitte wähle eine CSV-Datei aus!');
      return;
    }
    setLoading(true);
    setError('');
    setSuccess('');
    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await api.post('/contacts/import', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      const { created, updated } = response.data;
      setSuccess(`Import erfolgreich: ${created} neue, ${updated} vorhandene Kontakte verarbeitet.`);
    } catch (err) {
      console.error('Import-Fehler:', err);
      setError(err.response?.data?.error || 'Import fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
      <div style={{ width: '600px' }}>
        <Helmet>
          <title>Ansprechpartner per CSV importieren</title>
          <meta name="description" content="CSV-Import für Ansprechpartner (Besteller/LW-Bediener)" />
        </Helmet>

        <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>CSV-Import für Ansprechpartner</h2>

        <div style={{
          display: 'grid',
          gridTemplateColumns: '3fr 1fr auto',
          gap: '10px',
          alignItems: 'center',
          marginBottom: '20px'
        }}>
          <input
            type="file"
            accept=".csv"
            onChange={handleFileChange}
            style={{ padding: '5px', border: '1px solid #ccc', borderRadius: '4px' }}
          />
          <button
            onClick={handleImport}
            disabled={loading}
            style={{
              padding: '6px 12px',
              background: loading ? '#6c757d' : '#007bff',
              color: '#fff', border: 'none', borderRadius: '4px',
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? 'Import läuft…' : 'Import starten'}
          </button>
        </div>

        {error && <div style={{ color: '#dc3545', marginBottom: '10px' }}>{error}</div>}
        {success && <div style={{ color: '#28a745', marginBottom: '10px' }}>{success}</div>}
      </div>
    </div>
  );
};

export default ImportContactForm;